import { Link } from "react-router-dom";
import { useTheme } from "@/context/ThemeContext";

export default function HeroSection() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0ab727b674616473936a15cfe28fa7b3.jpg"
          alt="AI technology background"
          className="w-full h-full object-cover object-top"
        />
        <div className={`absolute inset-0 ${isDark ? "bg-gradient-to-b from-black/75 via-black/55 to-black/80" : "bg-gradient-to-b from-black/50 via-black/35 to-black/60"}`}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-10 text-center py-36">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/25 bg-white/8 backdrop-blur-sm mb-10">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"></span>
          <span className="text-white/80 text-[11px] tracking-[0.15em] uppercase font-medium">AI-Powered Business Systems</span>
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-[82px] font-black text-white leading-[1.02] tracking-[-0.02em] mb-7">
          Complete AI Systems That
          <br />
          <span className="text-white/55">Capture, Convert &amp; Scale</span>
        </h1>

        <p className="text-lg md:text-xl text-white/65 max-w-2xl mx-auto leading-relaxed mb-12 font-light">
          We design and deploy end-to-end AI systems that ensure every lead is captured, every follow-up happens instantly, and every opportunity turns into revenue.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="px-8 py-4 bg-white text-[#0a0a0a] text-[15px] font-semibold rounded-full hover:bg-white/92 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get Your AI System Audit
          </Link>
          <Link
            to="/case-studies"
            className="px-8 py-4 border border-white/30 text-white text-[15px] font-medium rounded-full hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            See Real Results
          </Link>
        </div>

        {/* Stats row */}
        <div className="mt-24 grid grid-cols-3 gap-6 max-w-xl mx-auto">
          {[
            { value: "55%", label: "More Booked Jobs" },
            { value: "<60s", label: "Response Time" },
            { value: "40%", label: "More Consultations" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-black text-white mb-1 tracking-tight">
                {stat.value}
              </div>
              <div className="text-white/40 text-[11px] tracking-[0.12em] uppercase font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5">
        <div className="w-px h-12 bg-gradient-to-b from-white/35 to-transparent animate-pulse"></div>
      </div>
    </section>
  );
}
